import React from 'react'
// One place for the state → tone mapping used by the org page, the sys
// Domains list and the org SSO tab (mirrors the email templates' tones).
const TONES = {
  verified: ['success', 'Verified'], at_risk: ['warning text-dark', 'At risk'],
  deactivated: ['danger', 'Deactivated'], pending: ['secondary', 'Pending'],
  // Staff allowed the domain to route without DNS proof. Not a kind of
  // verified: overrideDetail says what it means on hover and in row detail.
  overridden: ['info text-dark', 'Override'],
  // Job-run status (Task 21, GET /job + /job/:name/runs): a disjoint
  // vocabulary from the domain-lifecycle keys above, so a job_runs `status`
  // column value can be passed straight through as `tone` with no separate
  // derivation helper.
  succeeded: ['success', 'Succeeded'], skipped: ['secondary', 'Skipped'],
  failed: ['danger', 'Failed'], running: ['warning text-dark', 'Running'],
  // A run whose runner died before recording a result (core jobs ledger).
  abandoned: ['secondary', 'Abandoned']
}
export const domainTone = (row, now = Date.now()) => {
  const overridden = row.overrideAt && (!row.overrideUntil || new Date(row.overrideUntil).getTime() > now)
  return overridden ? 'overridden' : row.state
}
// The label StatusPill shows for a tone (for pages that draw their own pill).
export const statusPillLabel = tone => (TONES[tone] || [null, tone])[1]
export const StatusPill = ({ tone, title }) => {
  const [cls, label] = TONES[tone] || ['secondary', tone]
  return <span className={`badge rounded-pill bg-${cls}`} title={title}>{label}</span>
}

// What an override means, in one line, for the pill's hover and the row
// detail -- the same words everywhere. null when there is no override.
export const overrideDetail = row => {
  if (!row || !row.overrideAt) return null
  const until = row.overrideUntil
    ? ` until ${new Date(row.overrideUntil).toLocaleDateString()}`
    : ', no end date'
  const proof = row.lastOkAt ? '' : ' · no DNS proof yet'
  return `Allowed by EducationXR${until}${proof}`
}
